import React from "react";
import { Link } from "react-router-dom";
import Shape1 from "../assets/img/shape1.svg";
import HeroGirl from "../assets/img/hero-girl.png";
import Gp1 from "../assets/img/gp1.svg";
import Gp2 from "../assets/img/gp2.svg";
const Hero = () => {
    return (
        <><section className="sec-hero">
            <img src={Shape1} className='img-fluid shape1' alt="logo" />
            <div className="container-xl">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="hero-con">
                            <span>Never Stop Learning</span>
                            <h1 className="hero-title">Transform your skills, Transform your future — with Endorse Learning.</h1>
                            <a href="/courses" className="btn btn-green">Explore Courses</a>
                        </div>
                    </div>
                    <div className="col-lg-6 text-center">
                        <div className="girl-div">
                            <img src={Gp1} className='img-fluid Gp1' alt="" />
                            <img src={Gp2} className='img-fluid Gp2' alt="" />
                            <img src={HeroGirl} className='img-fluid hero-girl' alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section><section className="text-center">
                <div className="arrow-div">
                    <a href="#">
                    <i className="bi bi-arrow-down-short"></i>
                        <div className="arrow-border"></div>
                    </a>
                </div>
            </section>
        </>

    );
};

export default Hero;